<template>
  <div
    class="app-container clearfix"
    v-loading="openloading"
    element-loading-text="加载中"
    element-loading-background="rgba(0, 0, 0, 0.1)"
  >
    <el-row style="padding-bottom: 15px">
      <el-col :span="24">
        <h3 class="headtitle">问题分类维护</h3>
        <span>问题分类</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <el-row>
            <el-col>
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-plus"
                class="pull-right"
                @click="addInfo"
                v-if="isGranted('Pages.QuestionClasses.Create')"
                >新增</el-button
              >
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            size="mini"
            style="width: 100%; margin-top: 10px"
            border
          >
            <el-table-column
              label="操作"
              width="200"
              v-if="
                isGranted('Pages.QuestionClasses.Delete') ||
                isGranted('Pages.QuestionClass.Edit')
              "
            >
              <template slot-scope="scope">
                <el-tooltip content="编辑" placement="bottom">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    circle
                    @click="editRow(scope.row)"
                    size="mini"
                    v-if="isGranted('Pages.QuestionClasses.Edit')"
                  ></el-button>
                </el-tooltip>
                <!-- <el-tooltip content="删除" placement="bottom">
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="deleteEntity(scope.row._id)"
                    size="mini"
                    v-if="isGranted('Pages.QuestionClass.Delete')"
                  ></el-button>
                </el-tooltip>-->
              </template>
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="问题分类名称"
              align="center"
            >
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column label="问题分类编码" align="center">
              <template slot-scope="scope">{{ scope.row.code }}</template>
            </el-table-column>
          </el-table>
          <pagerBar
            ref="refPagerBar"
            :apiURL="questionClassGetAllUrl"
            :GetData="initData"
            :queryParam="queryParams"
            :errorFunc="closeOpenloading"
          ></pagerBar>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      v-el-drag-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="38%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-width="110px"
        :model="formLabel"
        :rules="rules"
        ref="questionClassEditForm"
      >
        <el-form-item label="问题分类名称">
          <el-input
            v-model="formLabel.name"
            placeholder="请输入问题分类名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题分类编码">
          <el-input
            v-model="formLabel.code"
            placeholder="问题分类编码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="SaveEntity()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";
export default {
  data() {
    return {
      //TODO
      openloading: true,
      dialogVisible: false, // 弹窗显示
      tableData: [],
      questionClassUrl: config.BASE_Middle_API + "QuestionClass",
      //问题分类列表数据获取
      questionClassGetAllUrl: config.BASE_Middle_API + "QuestionClass/GetAll",
      //新增or修改
      createOrEditUrl: config.BASE_Middle_API + "QuestionClass/Add",
      //删除
      deleteUrl: config.BASE_Middle_API + "QuestionClass/Delete",
      //得到信息实体
      GetEntityUrl: config.BASE_Middle_API + "QuestionClass/Edit",
      title: "新增问题分类",
      operation: "",
      formLabel: {
        code: "",
        name: "",
      },
      queryParams: { ArchiveFilter: "" },
      rules: {
        typeName: [
          {
            required: true,
            message: "请输入问题分类名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    pagerBar,
  },
  methods: {
    closeOpenloading() {
      this.openloading = false;
    },
    //新增问题分类
    addInfo() {
      this.clearformLabel();
      this.dialogVisible = true;
      this.operation = "add";
      this.title = "新增问题分类";
    },
    clearformLabel() {
      const _this = this;
      _this.formLabel.code = "";
      _this.formLabel.name = "";
    },
    initData(d) {
      const _this = this;
      _this.tableData = d;
      _this.openloading = false;
    },
    //编辑
    editRow(row) {
      const _this = this;
      _this.title = "编辑问题分类";
      _this.operation = "edit";
      this.dialogVisible = true;
      _this.formLabel = Object.assign({}, row);
    },
    deleteEntity(deleteId) {
      const _this = this;
      this.$confirm("此操作将删除该问题分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          AjaxHelper.delete(_this.deleteUrl, {
            tempId: deleteId,
          })
            .then(function (response) {
              if (response.success) {
                _this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                _this.Refresh();
              }
            })
            .catch(function (error) {
              // _this.$message({
              //   type: "danger",
              //   message: error
              // });
            });
        })
        .catch((e) => {
          _this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //保存基础资料档案
    SaveEntity() {
      const _this = this;
      this.$refs["questionClassEditForm"].validate((valid) => {
        let postUrl = "";
        if (_this.operation == "add") {
          postUrl = "/Add";
        } else {
          postUrl = "/Edit";
        }
        _this.formLabel.tempId = _this.formLabel._id;
        if (valid) {
          AjaxHelper.post(_this.questionClassUrl + postUrl, _this.formLabel)
            .then(function (response) {
              if (response.success) {
                _this.$message({
                  type: "success",
                  message: "操作成功",
                });
                _this.pagesize = 1;
                _this.clearformLabel();
                _this.Refresh();
                _this.dialogVisible = !_this.dialogVisible;
              } else {
                _this.$message({
                  type: "error",
                  message: response.Messages[0],
                });
              }
            })
            .catch(function (error) {
              _this.$message({
                type: "error",
                message: error,
              });
            });
        }
      });
    },
    Refresh() {
      this.$refs.refPagerBar.Refresh();
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style scoped="scoped">
dt,
dd {
  margin: 0;
  padding: 0;
}
.el-card {
  height: calc(100vh - 217px) !important;
}
</style>